exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.fullscreen-loader {\n  position: absolute;\n  min-height: calc(100vh - 25px);\n  width: 100%;\n  background: #e9e9e9;\n  opacity: 0.5;\n  z-index: 99;\n}\ndiv.fullscreen-loader svg {\n  display: block;\n  margin: 0 auto;\n  position: absolute;\n  top: calc(50% - 50px);\n  left: calc(50% - 50px);\n}\ndiv.fullscreen-loader svg path,\ndiv.fullscreen-loader svg rect {\n  fill: #c8017d;\n}", ""]);

// exports
